/**
 * Universal Footer — MentionFox
 *
 * There is now exactly one footer on the site. This file used to render its
 * own one-line bar, which is why an app page and a static page never looked
 * alike; both exports now render the canonical SiteFooter, whose markup comes
 * from src/shared/site-footer.html — the same file injected into every static
 * page in public/.
 *
 * Footer and InAppFooter are kept as separate names only because ~22 call
 * sites import them; they render the same thing.
 */
import { SiteFooter } from "@/components/site/SiteFooter";

export function Footer() {
  return <SiteFooter />;
}

export function InAppFooter() {
  return <SiteFooter />;
}

export default Footer;
